export default "__VITE_ASSET__BhX$b6pP__"